import React, { memo } from 'react';

import { translate } from '../utils';
import { is768Query } from '~/core/scripts/mediaquery-helper';

function getTicks(ticks = []) {
  if (!ticks.length) {
    return [];
  }

  if (is768Query() || ticks.length === 1) {
    return ticks;
  }

  return ticks.filter(t => ['2010', '2013', '2016', '2019'].includes(t.value));
}

function getTextAnchor(i, nodes) {
  if (i === 0) {
    return 'start';
  }

  if (i === nodes.length - 1) {
    return 'end';
  }

  return 'middle';
}

function getDx(i, nodes) {
  if (is768Query()) {
    return 0;
  }

  switch (i) {
    case 0:
      return '-0.25em';
    case nodes.length - 1:
      return '0.25em';
    default:
      return 0;
  }
}

function getTextX(i, ticks, xScale) {
  if (i === 0) {
    return 0;
  } else if (i === ticks.length - 1) {
    return xScale.bandwidth();
  }

  return xScale.bandwidth() * 0.5;
}

const XAxis = memo(({ margin, width, height, ticks, xScale, drawTickLines }) => {
  const cleanTicks = getTicks(ticks);

  return (
    <g className="chart__xaxis chart__axis" transform={translate(0, height - margin.bottom + 0.5)}>
      {false && (
        <line className="domain" stroke="currentColor" x1={margin.left} y1="0" x2={width - margin.right} y2="0" />
      )}
      {cleanTicks.map((d, i, nodes) => (
        <g className="tick" transform={translate(~~xScale(d.value) + 0.5, 0)} key={`xaxis__${d.value}`}>
          {drawTickLines && <line stroke="currentColor" y2="6" />}
          <text
            fill="currentColor"
            x={getTextX(i, ticks, xScale)}
            y="9"
            dy="0.71em"
            dx={getDx(i, nodes)}
            textAnchor={getTextAnchor(i, nodes)}
          >
            {d.label}
          </text>
        </g>
      ))}
    </g>
  );
});

XAxis.displayName = 'XAxis';

export default XAxis;
